// extracted by mini-css-extract-plugin
export default {"modalOverlay":"IB-z","modalContent":"JB-z","header":"KB-z","close":"LB-z"};